import React from 'react';
import { Heading } from '@certilogo/design-system-web';

function NotFoundPage() {
  return <Heading>Page Not Found</Heading>;
}

export default NotFoundPage;
